import AbstractController from '../../../../vendors/services/abstractController';
import {useState} from 'react';
import EventoConstants from '../../../pages/DefaultPage/Evento/utils/EventoConstants';
import ToastService from '../../../../vendors/services/toastService';
import {Mensagem} from '../../../shared/mensagem/Mensagem';

export default class FileUploadController extends AbstractController {


  public setIsUploaded: any;

  public show: any;
  public setShow: any;

  constructor() {
    super();
    [this.show, this.setShow] = useState(true);
  }


  public getFile(id: string, onUpload: any) {
    let dom: any = document.getElementById(id);
    dom = dom && dom.files ? dom.files : [];
    if (dom && dom.length <= 0) {
      return;
    }
    const file: any = dom[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    if (!this.tipoValido(file)) {
      ToastService.showWarn(Mensagem.MSG_E021);
      this.refresh();
      return;
    }
    if (!this.tamanhoValido(file)) {
      ToastService.showWarn(Mensagem.MSG_E048);
      this.refresh();
      return;
    }
    const that = this;
    that.start();
    reader.onload = function () {
      that.stop();
      onUpload({file: file, reader: reader});
      that.refresh();
    };
    reader.onerror = function (error: any) {
      return error(true);
    };
  }

  tamanhoValido(file: any) {
    return file.size <= EventoConstants.MAX_FILE_UPLOAD;
  }

  tipoValido(file: any) {
    const list = file.name.split('.');
    if (list.length > 0) {
      const type = list[list.length - 1];
      return EventoConstants.FILE_TYPES.indexOf(type) >= 0;
    }
    return false;
  }

  refresh() {
    this.setShow(false);
    const that = this;
    setTimeout(() => {
      that.setShow(true);
    }, 500);
  }

}